<template>
  <div class="material-list">
    <div v-if="formItem.value.length" class="material-content">
      <div
        v-for="(item, index) in formItem.value"
        :key="index"
        class="material-item"
      >
        <el-card>
          <div class="item-content">
            <el-image
              fit="contain"
              :src="item"
            />
            <div class="img-func">
              <el-button
                class="el-button-scale"
                icon="el-icon-zoom-in"
                circle
                @click.stop="openViewer(formItem.value, index)"
              />
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <el-empty v-else :image-size="100" description="暂无数据" />
    <el-image-viewer
      v-if="view_config.is_show"
      :z-index="3000"
      :initial-index="view_config.index"
      :on-close="() => view_config.is_show = false"
      :url-list="view_config.list"
    />
  </div>
</template>

<script>
export default {
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
  },
  props: {
    // 表单项配置
    formItem: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // 预览配置
      view_config: {
        is_show: false,
        index: null,
        list: [],
      },
    };
  },
  methods: {
    /**
     * 预览
     * @param {Object[]} list 预览列表
     * @param {number} index 下标
     */
    openViewer(list, index) {
      Object.assign(this.view_config, {
        is_show: true,
        index,
        list,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-card {
  width: 100%;
  height: 100%;
  overflow: initial;
  .el-card__body {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 10px;
    display: flex;
    flex-direction: column;
    padding-bottom: 0;
  }
}
.el-empty {
  height: 220px;
  border: 1px solid #ebebeb;
  border-radius: 3px;
}
.material-list {
  .material-content {
    padding: 10px;
    height: 220px;
    overflow: auto;
    border: 1px solid #ebebeb;
    border-radius: 3px;
    .material-item {
      display: inline-block;
      width: 33.3%;
      height: 100%;
      padding: 10px;
      .item-content {
          flex: 1;
          min-height: 0;
          position: relative;
        }
      .el-image {
        width: 100%;
        height: 100%;
        background-color: #333;
        object-fit: contain
      }
      .img-func {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        overflow: hidden;
        transition: all .3s;
        .el-button.el-button-scale {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          width: 36px;
          height: 36px;
          margin: auto;
          background-color: #3333336e; color: #fff;
          &:hover {
            transform: scale(1.2);
          }
        }
      }
    }
  }
}

</style>
